import React from 'react';

export const ITEMS_PER_PAGE = 10;

interface TableStatsProps {
  page: number;
  total: number;
  pageSize?: number;
}

const TableStats = (props: TableStatsProps) => {
  const { page, pageSize = ITEMS_PER_PAGE, total } = props;
  const start = page === 1 ? 1 : pageSize * (page - 1) + 1;
  const end = total - pageSize * page < 0 ? total : pageSize * page;
  return (
    <div className="ml-2 my-2">{`Showing ${ total > 0 ? `${start} to ${end} of ` : '' } ${total} entries`}</div>
  );
};

TableStats.defaultProps = {
  pageSize: ITEMS_PER_PAGE
};

export default TableStats;
